import { formatsByName } from '@ensdomains/address-encoder'

const COIN_LIST = Object.keys(formatsByName)

export default COIN_LIST
